import {Injectable, TemplateRef} from "@angular/core";
import {ModalRenderer} from "./ModalRenderer";
import {ModalInstance} from "./ModalInstance";
import {IModalOptions} from "./IModalOptions";
import {ModalStack} from "./ModalStack";
import {N_MODAL_LAYER_SELECTOR} from "./components/n-modal-layer/n-modal-layer.component";
import {ModalEventsService} from "./ModalEventsService";

let stack: ModalStack;

@Injectable({providedIn: "root"})
export class ModalService {

  constructor(private modalRenderer: ModalRenderer, private modalEventsSvc: ModalEventsService) {
    if (!stack) {
      stack = new ModalStack();
    }
  }

  get openModalEvents() {
    return this.modalEventsSvc.openModalEvents;
  }

  open<TResult>(componentType: Function, options?: IModalOptions, modalData?: any): ModalInstance<TResult> {
    if (!stack) {
      throw new Error("not initialized");
    }
    const instance = stack.open<TResult>(this.modalRenderer, modalData, componentType, undefined, options);
    this.openModalEvents.emit(instance);
    return instance;
  }

  openTemplate<TResult>(template: TemplateRef<any>, options?: IModalOptions): ModalInstance<TResult> {
    if (!stack) {
      throw new Error("not initialized");
    }
    const instance = stack.open<TResult>(this.modalRenderer, {}, undefined, template, options);
    this.openModalEvents.emit(instance);
    return instance;
  }

  isOpen() {
    return stack.openedVisibleModalCount > 0;
  }

  focusTopModal() {
    if (stack.openedVisibleModalCount > 0) {
      stack.getLast().focus();
    }
  }

  getModalContainer() {
    return document.querySelector<Element>(N_MODAL_LAYER_SELECTOR + ":last-of-type");
  }

  getLast(): ModalInstance<any> {
    return stack.getLast();
  }

  closeLast() {
    return stack.closeLast();
  }

  getModalCount() {
    return stack.openedModalCount;
  }
}
